import { useEffect, useRef, useState } from 'react';

const WIN_SCREEN_DURATION = 2000;
export const WIN_SCREEN_EXIT_DURATION = 600;

export const useShowTimers = (isFirstPlace: boolean) => {
    const [showWinScreen, setShowWinScreen] = useState(isFirstPlace);
    const [showLeaderboard, setShowLeaderboard] = useState(!isFirstPlace);
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const leaderboardTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => {
        if (isFirstPlace) {
            setShowWinScreen(true);
            setShowLeaderboard(false);
            timerRef.current = setTimeout(() => {
                setShowWinScreen(false);
                leaderboardTimerRef.current = setTimeout(() => {
                    setShowLeaderboard(true);
                }, WIN_SCREEN_EXIT_DURATION);
            }, WIN_SCREEN_DURATION);
        } else {
            setShowWinScreen(false);
            setShowLeaderboard(true);
        }
        return () => {
            if (timerRef.current) clearTimeout(timerRef.current);
            if (leaderboardTimerRef.current) clearTimeout(leaderboardTimerRef.current);
        };
    }, [isFirstPlace]);

    return { showWinScreen, showLeaderboard };
};
